import { Tooltip } from 'antd';
import nextIcon from 'Assets/icon/next-icon.svg';

const PointAddressIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11" cy="11" r="8.25" stroke="var(--s247-primary, #EE5B33)" strokeWidth="1.5"/>
    <circle cx="11" cy="11" r="4" fill="var(--s247-primary, #EE5B33)"/>
  </svg>
);

const DashedRouteIcon = () => (
  <svg width="2" height="56" viewBox="0 0 2 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L0.999998 55" stroke="var(--s247-primary, #EE5B33)" strokeLinecap="round" strokeDasharray="2 2"/>
  </svg>
);

export const PostOfficeMapIcon = () => (
  <svg width="25" height="36" viewBox="0 0 25 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.8867 11.0679H4.97734C2.7813 11.0679 1 12.8492 1 15.0452V30.9546C1 33.1506 2.7813 34.9319 4.97734 34.9319H20.8867C23.0827 34.9319 24.864 33.1506 24.864 30.9546V15.0452C24.8572 12.8492 23.0827 11.0679 20.8867 11.0679Z" fill="white" stroke="#D6DCDF" strokeWidth="0.2" strokeMiterlimit="10"/>
    <path d="M4.97625 12.6587H20.8856C22.2046 12.6587 23.272 13.7261 23.272 15.0451V18.9001L2.58984 15.9425V15.0451C2.58984 13.7261 3.65727 12.6587 4.97625 12.6587Z" fill="#E3E6F1"/>
    <path d="M2.58984 30.9543V17.5537L11.2108 18.7843L8.30089 33.3407H4.97625C3.65727 33.3339 2.58984 32.2665 2.58984 30.9543Z" fill="#E5E6F1"/>
    <path d="M20.8856 33.3408H9.92578L12.7949 19.0088L23.2788 20.5045V30.9476C23.2652 32.2666 22.1977 33.334 20.8856 33.3408Z" fill="#E5E6F1"/>
    <path d="M17.6183 21.3874C18.1258 21.3874 18.5373 20.9759 18.5373 20.4684C18.5373 19.9608 18.1258 19.5493 17.6183 19.5493C17.1107 19.5493 16.6992 19.9608 16.6992 20.4684C16.6992 20.9759 17.1107 21.3874 17.6183 21.3874Z" fill="var(--s247-primary, #EE5B33)"/>
    <path d="M17.6175 0C13.9321 0 10.9336 2.9985 10.9336 6.68389C10.9336 8.14235 11.3943 9.52814 12.2669 10.6908L17.2055 17.3421C17.2178 17.3582 17.2367 17.3644 17.2504 17.3788C17.4972 17.6431 17.8533 17.5766 18.0291 17.3421C19.4513 15.4446 22.058 11.9008 23.0602 10.564C23.0602 10.564 23.0606 10.5629 23.0609 10.5623L23.0671 10.554C23.8746 9.41949 24.3014 8.08134 24.3014 6.68389C24.3014 2.9985 21.3029 0 17.6175 0ZM17.6175 10.2898C15.6332 10.2898 14.0116 8.66815 14.0116 6.68389C14.0116 4.69963 15.6332 3.07802 17.6175 3.07802C19.6017 3.07802 21.2234 4.69963 21.2234 6.68389C21.2234 8.66815 19.6017 10.2898 17.6175 10.2898Z" fill="var(--s247-primary, #EE5B33)"/>
  </svg>
);
import { endsWith, startsWith } from 'lodash';
import { DeliveryTypeEnum } from 'Pages/C2cOrderPayment/enums';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import C2cOverPaymentServiceV1 from 'Services/v1/c2c-order-payment';
import {
  c2cOrderPaymentSelectors,
  selectReceiverPointAction,
  selectSenderPointAction
} from 'Stores/c2c-order-payment';
import { orderBillSelectors } from 'Stores/order-bill';
import { DeliveryMethodEnum } from '../../enums';
import './styles.scss';

interface PropsModel {
  className?: string;
}

const DeliveryAddress = (props: PropsModel) => {
  const { className = '' } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { deliveryMethodSelected, selectReceiverPoint, selectSenderPoint } =
    useSelector(c2cOrderPaymentSelectors.get);

  const { senderAddress, receiverAddress } = useSelector(
    orderBillSelectors.get
  );

  const getSenderName = useCallback(() => {
    switch (deliveryMethodSelected?.deliveryType) {
      case DeliveryTypeEnum.D2D:
      case DeliveryTypeEnum.D2P:
        return senderAddress?.personName;
      case DeliveryTypeEnum.P2D:
      case DeliveryTypeEnum.P2P:
        return selectSenderPoint?.name;
    }
  }, [deliveryMethodSelected, senderAddress, selectSenderPoint]);

  const getSenderAddress = useCallback(() => {
    switch (deliveryMethodSelected?.deliveryType) {
      case DeliveryTypeEnum.D2D:
      case DeliveryTypeEnum.D2P:
        return senderAddress?.address;
      case DeliveryTypeEnum.P2D:
      case DeliveryTypeEnum.P2P:
        return selectSenderPoint?.address;
    }
  }, [deliveryMethodSelected, senderAddress, selectSenderPoint]);

  const getReceiverName = useCallback(() => {
    switch (deliveryMethodSelected?.deliveryType) {
      case DeliveryTypeEnum.D2D:
      case DeliveryTypeEnum.P2D:
        return receiverAddress?.personName;
      case DeliveryTypeEnum.D2P:
      case DeliveryTypeEnum.P2P:
        return selectReceiverPoint?.name;
    }
  }, [deliveryMethodSelected, receiverAddress, selectReceiverPoint]);

  const getReceiverAddress = useCallback(() => {
    switch (deliveryMethodSelected?.deliveryType) {
      case DeliveryTypeEnum.D2D:
      case DeliveryTypeEnum.P2D:
        return receiverAddress?.address;
      case DeliveryTypeEnum.D2P:
      case DeliveryTypeEnum.P2P:
        return selectReceiverPoint?.address;
    }
  }, [deliveryMethodSelected, receiverAddress, selectReceiverPoint]);

  const isSenderPostOffice = startsWith(
    deliveryMethodSelected?.deliveryType,
    'P'
  );
  const isReceiverPostOffice = endsWith(
    deliveryMethodSelected?.deliveryType,
    'P'
  );

  // const openPopup = usePopup() as UsePopupModel;

  // const showPopupOffice = (type: string) => {
  //   const config = {
  //     ...CONFIRM_SELECT_PRODUCT_POPUP,
  //     title: t(ChoosePostOfficeTextEnum.ChoosePostOffice_Title),
  //     minWidth: '40vw',
  //     hideBtnCancel: true,
  //     hideBtnOk: true,
  //   };
  //   openPopup.onOpen(<CommonPopupLayout popupConfig={config}><ChoosePostOfficeContainer type={type}></ChoosePostOfficeContainer></CommonPopupLayout>, data => console.log(data))
  // }

  useEffect(() => {
    if (
      (selectSenderPoint && Object.keys(selectSenderPoint).length > 0) ||
      (selectReceiverPoint && Object.keys(selectReceiverPoint).length > 0)
    ) {
      return;
    }
    if (!isReceiverPostOffice) {
      dispatch(selectReceiverPointAction({}));
    } else {
      // Find Post Office
      // Tìm địa chỉ bưu cựu của người nhận
      C2cOverPaymentServiceV1.getPostOffice(
        receiverAddress?.lat || '',
        receiverAddress?.long || ''
      ).then(res => {
        const dropPoints = res.data! || [];

        if (dropPoints.length > 0) {
          let item = dropPoints.find(
            item => item.id === deliveryMethodSelected?.originDop
          );
          if (!item) item = dropPoints[0];
          const point = {
            id: item?.id,
            name: item?.name,
            address: item?.address,
            latitude: item?.geo?.coordinates[1],
            longitude: item?.geo?.coordinates[0],
            code: item?.code
          };

          dispatch(selectReceiverPointAction(point));
        } else {
          dispatch(selectReceiverPointAction({}));
        }
      });
    }

    if (!isSenderPostOffice) {
      dispatch(selectSenderPointAction({}));
    } else {
      // Tìm địa chỉ bưu cục gần người gửi
      C2cOverPaymentServiceV1.getPostOffice(
        senderAddress?.lat || '',
        senderAddress?.long || ''
      ).then(res => {
        const dropPoints = res.data! || [];

        if (dropPoints.length > 0) {
          let item = dropPoints.find(
            item => item.id === deliveryMethodSelected?.originDop
          );
          if (!item) item = dropPoints[0];
          const point = {
            id: item?.id,
            name: item?.name,
            address: item?.address,
            latitude: item?.geo?.coordinates[1],
            longitude: item?.geo?.coordinates[0],
            code: item?.code
          };
          dispatch(selectSenderPointAction(point));
        } else {
          dispatch(selectSenderPointAction({}));
        }
      });
    }
  }, [
    senderAddress,
    receiverAddress,
    deliveryMethodSelected?.deliveryType
    // isSenderPostOffice,
    // isReceiverPostOffice,
  ]);

  return (
    <div className={`${className} delivery-address`}>
      <div className="delivery-address-icon">
        <div className="delivery-address-icon-point"><PointAddressIcon /></div>
        <div className="delivery-address-icon-dashed"><DashedRouteIcon /></div>
        <div className="delivery-address-icon-post-office"><PostOfficeMapIcon /></div>
      </div>
      <div className="delivery-address-addresses">
        <div
          onClick={() => {
            isSenderPostOffice &&
              navigate('/choose-post-office', {
                state: {
                  type: 'sender'
                }
              });
          }}
          className="delivery-address-departure"
        >
          <div>
            <div>
              {isSenderPostOffice && (
                <span>
                  {t(DeliveryMethodEnum.DeliveryAddress_DeliveryAt)}:{' '}
                </span>
              )}
              <span className="title-medium-15">{getSenderName()}</span>
            </div>
            <Tooltip
              placement="topLeft"
              overlayClassName="tooltip-address"
              overlayStyle={{ maxWidth: '500px' }}
              overlayInnerStyle={{ borderRadius: '5px' }}
              title={getSenderAddress()}
            >
              <div className="text-gray-primary dot">{getSenderAddress()}</div>
            </Tooltip>
          </div>
          {isSenderPostOffice && (
            <img className="" src={nextIcon} alt="next-icon"></img>
          )}
        </div>
        <div
          onClick={() => {
            isReceiverPostOffice &&
              navigate('/choose-post-office', {
                state: {
                  type: 'receiver'
                }
              });
          }}
          className="delivery-address-destination divider-border-bottom"
        >
          <div>
            {isReceiverPostOffice && (
              <span>{t(DeliveryMethodEnum.DeliveryAddress_ReceiveAt)}: </span>
            )}
            <span className="title-medium-15">
              {getReceiverName()}
              {/* <span className="text-gray-primary">{'930303030'}</span> */}
            </span>
            <Tooltip
              placement="topLeft"
              overlayClassName="tooltip-address"
              overlayStyle={{ maxWidth: '500px' }}
              overlayInnerStyle={{ borderRadius: '5px' }}
              title={getReceiverAddress()}
            >
              <div className="text-gray-primary dot">
                {getReceiverAddress()}
              </div>
            </Tooltip>
          </div>
          {isReceiverPostOffice && (
            <img className="" src={nextIcon} alt="next-icon"></img>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeliveryAddress;
